/**
 * FinancialMetrics Component
 * Grid of financial metric cards for the Gateway Dashboard
 */

import { useSnapshot } from "valtio";
import {
  financialStore,
  formatCurrency,
  formatCompactCurrency,
} from "../stores/financial";
import MetricCard from "@/components/MetricCard";
import { Skeleton } from "@/components/ui/skeleton";
import { DollarSign, TrendingUp, Percent, Users } from "lucide-react";

export default function FinancialMetrics() {
  const { overview, loading } = useSnapshot(financialStore);

  if (loading && !overview) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-[120px]" />
        ))}
      </div>
    );
  }

  // Calculate trends (mock for now - would compare to previous period)
  const mrrTrend = { value: 8, isPositive: true };
  const profitTrend = { value: 12, isPositive: true };
  const marginTrend = { value: 2, isPositive: true };
  const subscribersTrend = { value: 5, isPositive: true };

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        title="Monthly Recurring Revenue"
        value={overview ? formatCompactCurrency(overview.mrr) : "$0"}
        subtitle="Active subscriptions"
        trend={mrrTrend}
        icon={<DollarSign className="h-4 w-4" />}
      />
      <MetricCard
        title="Net Profit"
        value={overview ? formatCompactCurrency(overview.netProfit) : "$0"}
        subtitle={`Costs: ${overview ? formatCurrency(overview.totalCosts) : "$0"}`}
        trend={profitTrend}
        icon={<TrendingUp className="h-4 w-4" />}
      />
      <MetricCard
        title="Gross Margin"
        value={overview ? `${overview.grossMargin}%` : "0%"}
        subtitle="Revenue - Costs / Revenue"
        trend={marginTrend}
        icon={<Percent className="h-4 w-4" />}
      />
      <MetricCard
        title="Active Subscribers"
        value={overview?.activeSubscribers ?? 0}
        subtitle={`ARPU: ${overview ? formatCurrency(overview.arpu) : "$0"}`}
        trend={subscribersTrend}
        icon={<Users className="h-4 w-4" />}
      />
    </div>
  );
}
